import { render, staticRenderFns } from "./NewItemRegist.vue?vue&type=template&id=f9e21686&"
import script from "./NewItemRegist.vue?vue&type=script&lang=js&"
export * from "./NewItemRegist.vue?vue&type=script&lang=js&"
import style0 from "./NewItemRegist.vue?vue&type=style&index=0&id=f9e21686&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports